import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { gosafeApi } from "../../api";
import {
  setSelectOptions,
  setSelectLoading,
  setSelectError,
} from "../../store/admin/selectOptionsSlice";
import { translations } from "../../helpers";

export const useSelectOptionsStore = () => {
  const dispatch = useDispatch();

  const { proceduresParent, procedures, years, satisfactionQuestions, months } =
    useSelector((state) => state.admin.selectOptions);

  const startGetProceduresParent = useCallback(async () => {
    try {
      dispatch(setSelectLoading({ key: "proceduresParent" }));

      const { data } = await gosafeApi.get(`demographic/procedure`);

      dispatch(
        setSelectOptions({
          key: "proceduresParent",
          data,
        })
      );
      return;
    } catch (error) {
      const errorMessage =
        translations[error?.response?.data?.message] ||
        error?.response?.data?.message ||
        error?.message;

      dispatch(
        setSelectError({
          key: "proceduresParent",
          message: errorMessage,
        })
      );
      return;
    }
  }, [dispatch]);

  const startGetProcedurechildren = useCallback(
    async (procedureParentId) => {
      try {
        dispatch(
          setSelectOptions({
            key: "procedures",
            data: [],
          })
        );

        dispatch(setSelectLoading({ key: "procedures" }));

        const { data } = await gosafeApi.get(
          `procedure/byProcedureParentId/${procedureParentId}`
        );

        dispatch(
          setSelectOptions({
            key: "procedures",
            data,
          })
        );
        return;
      } catch (error) {
        const errorMessage =
          translations[error?.response?.data?.message] ||
          error?.response?.data?.message ||
          error?.message;

        dispatch(
          setSelectError({
            key: "procedures",
            message: errorMessage,
          })
        );
        return;
      }
    },
    [dispatch]
  );

  const startGetSatisfactionQuestions = useCallback(async () => {
    try {
      dispatch(setSelectLoading({ key: "satisfactionQuestions" }));

      const { data } = await gosafeApi.get(`demographic/satisfactionQuestions`);

      dispatch(
        setSelectOptions({
          key: "satisfactionQuestions",
          data,
        })
      );
      return;
    } catch (error) {
      const errorMessage =
        translations[error?.response?.data?.message] ||
        error?.response?.data?.message ||
        error?.message;

      dispatch(
        setSelectError({
          key: "satisfactionQuestions",
          message: errorMessage,
        })
      );
      return;
    }
  }, [dispatch]);

  return {
    // Props
    proceduresParent,
    procedures,
    years,
    satisfactionQuestions,
    months,

    // Methods
    startGetProceduresParent,
    startGetProcedurechildren,
    startGetSatisfactionQuestions,
  };
};
